module.exports = __webpack_public_path__ + "img/81.2dd5a9be.jpg";